<input type="file" id="{{ id }}" [disabled]="disabled" (input)="uploadFile($event)" class="input-file" />
